<div class="banner-container">
  <div [class]="countryClass"></div>
</div>
